import React from "react";
import footerImage from "../Assets/Images/footerMobile.png";

export default () => (
  <footer>
    <img src={footerImage} alt="Footer" />
  </footer>
);
